import { render, staticRenderFns } from "./Sars.vue?vue&type=template&id=dc25ab14&"
import script from "./Sars.vue?vue&type=script&lang=ts&"
export * from "./Sars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports